import { Card, CardContent } from "@/components/primitives";
import type { ReflectionStats } from "../types";

interface StatisticsCardsProps {
	stats: ReflectionStats;
}

export const StatisticsCards = ({ stats }: StatisticsCardsProps) => {
	return (
		<div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-8">
			<Card className="border-2 shadow-md bg-white/90 dark:bg-slate-800/90 backdrop-blur-sm">
				<CardContent className="p-4">
					<div className="text-center">
						<div className="text-2xl font-semibold text-green-600 dark:text-green-400">
							{stats.active}
						</div>
						<div className="text-sm text-muted-foreground mt-1">
							Active Reflections
						</div>
					</div>
				</CardContent>
			</Card>
			<Card className="border-2 shadow-md bg-white/90 dark:bg-slate-800/90 backdrop-blur-sm">
				<CardContent className="p-4">
					<div className="text-center">
						<div className="text-2xl font-semibold text-orange-600 dark:text-orange-400">
							{stats.drafts}
						</div>
						<div className="text-sm text-muted-foreground mt-1">
							Draft Reflections
						</div>
					</div>
				</CardContent>
			</Card>
			<Card className="border-2 shadow-md bg-white/90 dark:bg-slate-800/90 backdrop-blur-sm">
				<CardContent className="p-4">
					<div className="text-center">
						<div className="text-2xl font-semibold text-muted-foreground">
							{stats.archived}
						</div>
						<div className="text-sm text-muted-foreground mt-1">
							Archived Reflections
						</div>
					</div>
				</CardContent>
			</Card>
			<Card className="border-2 shadow-md bg-white/90 dark:bg-slate-800/90 backdrop-blur-sm">
				<CardContent className="p-4">
					<div className="text-center">
						<div className="text-2xl font-semibold text-foreground">
							{stats.total}
						</div>
						<div className="text-sm text-muted-foreground mt-1">
							Total Reflections
						</div>
					</div>
				</CardContent>
			</Card>
		</div>
	);
};
